import React, { Component } from 'react';
import * as R from 'ramda';
import '../../../../../index.css'
import { axiosClient } from '../../../../../store';
import imghistory from '../../../../../images/history.png';
import imgcomment from '../../../../../images/comment.png';
import imgfeedback from '../../../../../images/feedback.png';
import imgtick from '../../../../../images/Tick.png';
import moment from 'moment';
import EmojiReaction from '../../review/modals/EmojiReaction'

const INITIAL_STATE = {
    anchorEl: true,
    feedbackMessage: '',
    feeddbackSymbol: '',
    feedbackstatus: 1,
    feedbacktype: 'svr',
    docid: 0,
    isfeedback: false,
    ishistory: false,
    feedbackdata: [],
    historyicon: 'block',
    resolvetext: ''
};

class ClientFeedbackModal extends Component {
    state = INITIAL_STATE;

    // Appends ONLY the raw code string directly to the message state

    handleEmojiSelect = (emojiData) => {
        const { /* symbol, */ code } = emojiData;
        // const currentMessage = this.state.feedbackMessage;
        this.emojiSave(code);
    }

    emojiSave = async (code) => {
        const cuuid = this.uuidv4();
        //const emojiStatus = await this.isEmojiExistsInFeedback(this.state.feedbackdata, code);
        const datasvrFeedback = {
            canonicalkey: cuuid,
            feedbackstatus: this.state.feedbackstatus,
            feedbacktype: this.state.feedbacktype,
            docid: this.state.docid,
            storevisitid: this.props.storeVisitId,
            feedback_resolved_and_share_status: 'Y'
        }

        await axiosClient.post(`api/v2/svrfeedback/savefeedback`, datasvrFeedback, {
            headers: { Authorization: `Bearer ${JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).token}` }
        });

        const datasvrFeedbackinfo = {
            feedback_canonicalkey: cuuid,
            feedbacktext: code,
            createdby: JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).name === undefined
                ? this.props.userEmail.substring(0, this.props.userEmail.lastIndexOf("@")) :
                JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).name,
            createdbyemail: this.props.userEmail,
            emoji_applied: "true", //emojiStatus ? "false" : "true"
            feedback_resolved_and_share_status: 'Y'
        }

        await axiosClient.post(`api/v2/svrfeedbackinfo/savefeedbackinfo`, datasvrFeedbackinfo, {
            headers: { Authorization: `Bearer ${JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).token}` }
        });

        this.setState({ isfeedback: false, ishistory: true });
        this.getFeedbackData(this.props.storeVisitId);
    }

    getFeedbackData = async (id) => {
        const resposegetdatasvrFeedback = await axiosClient.get(
            `api/v2/svrfeedback/getfeedback/id/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).token}`
                }
            });

        if (resposegetdatasvrFeedback !== null && resposegetdatasvrFeedback !== undefined) {
            if (resposegetdatasvrFeedback.data !== null && resposegetdatasvrFeedback.data !== undefined) {
                if (resposegetdatasvrFeedback.data.data !== null && resposegetdatasvrFeedback.data.data !== undefined && resposegetdatasvrFeedback.data.data.length > 0) {
                    this.setState({ feedbackdata: resposegetdatasvrFeedback.data.data });
                }
                else if (resposegetdatasvrFeedback.data.data !== null && resposegetdatasvrFeedback.data.data !== undefined && resposegetdatasvrFeedback.data.data.length === undefined) {
                    const objdata = resposegetdatasvrFeedback.data.data;
                    const datatwo = {
                        createdby: objdata.createdby,
                        createdbyemail: objdata.createdbyemail,
                        createddate: objdata.createddate,
                        feedbacktext: objdata.feedbacktext,
                        feedbackresolvedstatus: objdata.feedbackresolvedstatus,
                        feedbackresolvedsharestatus: objdata.feedbackresolvedsharestatus,
                        feedbackresolvedstatusinfo: objdata.feedbackresolvedstatusinfo,
                        feedbackresolvedsharestatusinfo: objdata.feedbackresolvedsharestatusinfo,
                        emojiapplied: objdata.emojiapplied
                    }
                    this.setState({ feedbackdata: [datatwo] });
                }
                else {
                    this.setState({ feedbackdata: [] });
                }
            }
        }
    }

    getResolvecheck = async (id) => {
        const resposegetdatasvrFeedback = await axiosClient.get(
            `api/v2/svrfeedback/getfeedback/id/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).token}`
                }
            });

        if (resposegetdatasvrFeedback !== null && resposegetdatasvrFeedback !== undefined) {
            if (resposegetdatasvrFeedback.data !== null && resposegetdatasvrFeedback.data !== undefined) {
                if (resposegetdatasvrFeedback.data.data !== null && resposegetdatasvrFeedback.data.data !== undefined && resposegetdatasvrFeedback.data.data.length > 0) {
                    if (resposegetdatasvrFeedback.data.data["0"].feedbackresolvedstatus === "Y" || resposegetdatasvrFeedback.data.data["0"].feedbackresolvedsharestatus === "Y") {
                        this.setState({
                            ishistory: this.state.ishistory === true ? false : true,
                            isfeedback: false,
                            feedbackdata: resposegetdatasvrFeedback.data.data,
                            historyicon: 'none',
                            resolvetext: ''
                        });
                    }
                    else {
                        this.setState({ isfeedback: !this.state.isfeedback, ishistory: false });
                    }
                }
                else if (resposegetdatasvrFeedback.data.data !== null && resposegetdatasvrFeedback.data.data !== undefined && resposegetdatasvrFeedback.data.data.length === undefined) {
                    const objdata = resposegetdatasvrFeedback.data.data;
                    const datatwo = {
                        createdby: objdata.createdby,
                        createdbyemail: objdata.createdbyemail,
                        createddate: objdata.createddate,
                        feedbacktext: objdata.feedbacktext,
                        feedbackresolvedstatus: objdata.feedbackresolvedstatus,
                        feedbackresolvedsharestatus: objdata.feedbackresolvedsharestatus,
                        feedbackresolvedstatusinfo: objdata.feedbackresolvedstatusinfo,
                        feedbackresolvedsharestatusinfo: objdata.feedbackresolvedsharestatusinfo,
                        emojiapplied: objdata.emojiapplied
                    }

                    if (datatwo.feedbackresolvedstatus === "Y" || datatwo.feedbackresolvedsharestatus === "Y") {
                        this.setState({
                            ishistory: this.state.ishistory === true ? false : true,
                            isfeedback: false,
                            feedbackdata: [datatwo],
                            historyicon: 'none',
                            resolvetext: ''
                        });
                    }
                    else {
                        this.setState({ isfeedback: !this.state.isfeedback, ishistory: false });
                    }
                }
                else {
                    this.setState({ isfeedback: !this.state.isfeedback, ishistory: false });
                }
            }
        }
    }

    handleCancelFeedback = (e) => {
        this.setState({ feedbackMessage: "" /*, feeddbackSymbol: "" */, isfeedback: false });
    }

    showhideFeedback = (e) => id => { this.getResolvecheck(id); }
    showhideHistory = (e) => id => {
        this.setState({ ishistory: true, isfeedback: false });
        this.getFeedbackData(id);
    }
    hideHistory = (e) => { this.setState({ ishistory: false, isfeedback: true }); }

    uuidv4 = () => {
        var id_str = [];
        var hxDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            id_str[i] = hxDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        id_str[14] = "4";
        id_str[19] = hxDigits.substr((id_str[19] & 0x3) | 0x8, 1);
        id_str[8] = id_str[13] = id_str[18] = id_str[23] = "-";
        return id_str.join("");
    }

    handleSaveFeedback = async (e) => {
        if (this.state.feedbackMessage !== "" && this.state.feedbackMessage.trim() !== "") {
            document.getElementById("btnsavefeedback").disabled = true;
            const cuuid = this.uuidv4();

            const datasvrFeedback = {
                canonicalkey: cuuid,
                feedbackstatus: this.state.feedbackstatus,
                feedbacktype: this.state.feedbacktype,
                docid: this.state.docid,
                storevisitid: this.props.storeVisitId,
                feedback_resolved_and_share_status: 'N'
            }

            await axiosClient.post(`api/v2/svrfeedback/savefeedback`, datasvrFeedback, {
                headers: { Authorization: `Bearer ${JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).token}` }
            });

            const datasvrFeedbackinfo = {
                feedback_canonicalkey: cuuid,
                feedbacktext: this.state.feedbackMessage,
                createdby: JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).name === undefined
                    ? this.props.userEmail.substring(0, this.props.userEmail.lastIndexOf("@")) :
                    JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).name,
                createdbyemail: this.props.userEmail,
                emoji_applied: "false",
                feedback_resolved_and_share_status: 'N'
            }

            await axiosClient.post(`api/v2/svrfeedbackinfo/savefeedbackinfo`, datasvrFeedbackinfo, {
                headers: { Authorization: `Bearer ${JSON.parse(JSON.parse(window.localStorage.getItem('persist:root')).auth).token}` }
            });

            this.setState({
                feedbackMessage: ""
            });

            document.getElementById("svrfeedbackTextarea").value = "";
            document.getElementById("btnsavefeedback").disabled = false;
        }
    };



    handleChangedataFeedback = e => {
        if (e == null || e.target == null)
            return;
        this.setState({
            feedbackMessage: e.target.value.trim()
        });
    };

    transformEmojiCodeToRender = (emoji) => {
        if (!emoji || emoji === "-1" || !emoji.includes("0x")) return "";
        const hexArray = emoji.split(",");
        const codePoints = hexArray.map((hex) => parseInt(hex.trim(), 16));
        return String.fromCodePoint(...codePoints);
    };

    // isEmojiExistsInFeedback = (feedbackdata, selectedEmojiCode) => {
    //     if (!selectedEmojiCode || !feedbackdata?.length) return false;

    //     return feedbackdata?.some(fb => fb.emojiapplied === "true" && fb.feedbacktext === selectedEmojiCode);
    // };



    render() {
        const { isfeedback, ishistory, feedbackdata /*, feedbackMessage /*, feeddbackSymbol*/ } = this.state;
        const { storeVisitId } = this.props;
        return (
            <div>
                {ishistory ?
                    <div className="app-wrapper fix">
                        <div className="card-header">
                            <span>Client Feedback History{this.state.resolvetext}</span>
                            <img src={imgfeedback} onClick={e => { this.hideHistory(e); }} className='img-responsive' title="Feedback" alt='Feedback'></img>
                        </div>
                        <div className="app-message-body">
                            {R.map(dataFeedback =>
                                <div key={dataFeedback.createddate || this.uuidv4()} className="message-wrapper">
                                    <div className="message">
                                        <span>
                                            {(!R.isNil(dataFeedback.feedbacktext)
                                                && (dataFeedback.feedbackresolvedstatusinfo === 'Y'
                                                    || dataFeedback.feedbackresolvedsharestatusinfo === "Y")
                                                && dataFeedback.emojiapplied !== "true") ?
                                                <img style={{ paddingRight: 10 }} src={imgtick} className='img-responsive' title="Resolved" alt='Resolved'></img> : null}
                                        </span>
                                        <span>
                                            {dataFeedback.feedbacktext === undefined ? "No record found" :
                                                (dataFeedback.feedbacktext.includes("2764, FE0F") || dataFeedback.feedbacktext.includes("1F60D") ||
                                                    dataFeedback.feedbacktext.includes("1F44D") || dataFeedback.feedbacktext.includes("1F44F") ||
                                                    dataFeedback.feedbacktext.includes("1F389") || dataFeedback.feedbacktext.includes("1F4AF") ||
                                                    dataFeedback.feedbacktext.includes("1F929") || dataFeedback.feedbacktext.includes("1F64C") ||
                                                    dataFeedback.feedbacktext.includes("1F4AA") ||
                                                    dataFeedback.feedbacktext.includes("0x2764, 0xFE0F") || dataFeedback.feedbacktext.includes("0x1F60D") ||
                                                    dataFeedback.feedbacktext.includes("0x1F44D") || dataFeedback.feedbacktext.includes("0x1F44F") ||
                                                    dataFeedback.feedbacktext.includes("0x1F389") || dataFeedback.feedbacktext.includes("0x1F4AF") ||
                                                    dataFeedback.feedbacktext.includes("0x1F929") || dataFeedback.feedbacktext.includes("0x1F64C") ||
                                                    dataFeedback.feedbacktext.includes("0x1F4AA")
                                                )
                                                    ? this.transformEmojiCodeToRender(dataFeedback.feedbacktext)
                                                    : dataFeedback.feedbacktext}
                                        </span>
                                    </div>
                                    <div className="message-meta">
                                        <span className="timestamp"> {dataFeedback.feedbacktext === undefined ? "" : dataFeedback.createdby.concat(' - ').concat(moment(dataFeedback.createddate).format('MM/DD/YYYY'))}</span>
                                    </div>
                                </div>
                                , feedbackdata)}
                        </div>
                    </div> : null}

                {isfeedback ?
                    <div className="card fixed">
                        <div className="card-header">
                            <span>Client Feedback</span>
                            <span className='imgHistorytext-responsive'  onClick={e => { this.showhideHistory(e)(storeVisitId); }}  style={{ display: 'inline-flex', alignItems: 'center' }} >History <span><img alt='History' src={imghistory} onClick={e => { this.showhideHistory(e)(storeVisitId); }} className='img-responsive' title="History"></img></span></span>
                        </div>
                        <div className="form-floating">
                            <textarea className="form-control"
                                placeholder="Leave a comment here"
                                id="svrfeedbackTextarea"
                                onChange={e => this.handleChangedataFeedback(e)} rows="5"
                                required></textarea>
                        </div>

                        <div className="card-footer">
                            <div className="emojiaction">
                                <EmojiReaction onSelectEmoji={this.handleEmojiSelect} />
                            </div>
                            <div className="action">
                                <button id="btncancelfeedback" title="Cancel" type="button"
                                    onClick={e => { this.handleCancelFeedback(e); }} className="btn btn-cancel">Cancel</button>&nbsp;
                                <button id="btnsavefeedback" title="Save" type="button"
                                    onClick={e => { this.handleSaveFeedback(e); }} className="btn btn-save">Save</button>&nbsp;&nbsp;
                            </div>
                        </div>
                    </div>
                    : null}

                <div className="sticky-icon">
                    <p className="feedback">
                        <img src={imgcomment} onClick={e => { this.showhideFeedback(e)(storeVisitId); }} className='img-popup' alt='comment'></img>
                        <span onClick={e => { this.showhideFeedback(e)(storeVisitId); }} className="feedback-text">Send Feedback</span>
                    </p>
                </div>
            </div>
        );
    }
}

export default ClientFeedbackModal;